import Vue from 'vue';

import { httpClient } from '@api';

import { Filter } from './filter.dto';

export default {
  async list(params, tab) {
    const list = await httpClient.post('/filters/get-many', {
      companyId: Vue.prototype.$auth.user().selectedCompany.id,
      projection: {
        id: 1,
        title: 1,
        headers: 1,
        schedule: 1,
        breakdownByInvoice: 1,
        contentType: 1,
        renamedHeaders: 1,
        filter: 1,
        entity: 1,
        isShared: 1,
      },
      ...params,
    });

    const normalizedList = list.map((item) => new Filter(item));

    return normalizedList;
  },
  async updateOne(params) {
    return httpClient.post('/filters/update-one', {
      companyId: Vue.prototype.$auth.user().selectedCompany.id,
      ...params,
    });
  },
  async createOne(params) {
    return httpClient.post('/filters/create-one', {
      companyId: Vue.prototype.$auth.user().selectedCompany.id,
      ...params,
    });
  },
  async deleteOne(params) {
    return httpClient.post('/filters/delete-one', {
      companyId: Vue.prototype.$auth.user().selectedCompany.id,
      ...params,
    });
  },
};
